import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import "./UserHazardDetails.css";
import Sidebar from "../Components/Sidebar";

const UserHazardDetails = () => {
  const { hazardId } = useParams();
  const [data, setData] = useState(null);
  const [duration, setDuration] = useState(0);
  const videoRef = useRef(null);
  const progressRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("jwtToken");

    fetch(`${process.env.REACT_APP_API_URL}/user_hazard_info`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: hazardId }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) setData(res.data);
      });
  }, [hazardId]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleLoadedMetadata = () => setDuration(video.duration);
      const handleTimeUpdate = () => setCurrentTime(video.currentTime);

      video.addEventListener("loadedmetadata", handleLoadedMetadata);
      video.addEventListener("timeupdate", handleTimeUpdate);

      return () => {
        video.removeEventListener("loadedmetadata", handleLoadedMetadata);
        video.removeEventListener("timeupdate", handleTimeUpdate);
      };
    }
  }, [data]); // or [] if video src never changes

  const seek = (e) => {
    if (!progressRef.current || !videoRef.current) return;
    const rect = progressRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const percentage = clickX / rect.width;
    videoRef.current.currentTime = percentage * duration;
  };

  if (!data) return <p className="usr-hazard-loading">Loading...</p>;

  const { video, score, correct_timestamp, user_timestamps } = data;

  const renderMarkers = () => {
    const markers = [];

    if (duration === 0) return markers;

    const getLeft = (time) => `${(time / duration) * 100}%`;

    // Correct timestamp - green flag
    markers.push(
      <div
        key={"correct"}
        className="usr-hazard-flag-marker correct"
        style={{ left: getLeft(correct_timestamp) }}
        title={`Correct: ${correct_timestamp}s`}
      />
    );

    // User timestamps - red flags
    user_timestamps.forEach((t, i) => {
      markers.push(
        <div
          key={`user-${i}`}
          className="usr-hazard-flag-marker user"
          style={{ left: getLeft(t) }}
          title={`Your Click: ${t}s`}
        />
      );
    });

    return markers;
  };

  return (
    <div className="overview">
      <Sidebar />
      <div className="usr-hazard-detail">
        <h2>Hazard Review #{data.hazard_id}</h2>
        <p>Score: {score} / 5</p>
        <div className="usr-hazard-video-container">
          <video
            ref={videoRef}
            src={video}
            controls
            className="usr-hazard-video"
          />
          {/* Custom Timeline */}
          <div
            className="usr-hazard-progress-bar"
            ref={progressRef}
            onClick={seek}
          >
            <div
              className="usr-hazard-progress-fill"
              style={{ width: `${(currentTime / duration) * 100}%` }}
            />
            {renderMarkers()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserHazardDetails;
